module.exports = __webpack_public_path__ + "static/img/12.f947e742.png";